<template>
    <div class="card owners-card">
        <div class="card-body">
            <spinner v-if="loading"></spinner>

            <div v-if="!loading">
                <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 me-3">
                        <div class="avatar">
                            <div class="avatar-title rounded bg-primary bg-gradient">
                                <eva-icon name="people" class="fill-white"></eva-icon>
                            </div>
                        </div>
                    </div>
                    <div class="flex-grow-1">
                        <p class="text-muted mb-1">Número de propietarios</p>
                        <h4 class="mb-0" v-if="hasOwnersData()">{{ owners.toLocaleString('es-ES') }}</h4>
                        <NoDataMessage v-if="!hasOwnersData()"></NoDataMessage>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import spinner from '../../../../../components/spinner.vue';
import NoDataMessage from "@/views/pages/dashboard/fynkus/components/no-data-message.vue";
export default {
    components: {NoDataMessage, spinner },
    name: "OwnersCard",
    props: {
        owners: {
            type: Number,
            default: 0,
        },
        loading: {
          type: Boolean,
          default: false,
        },
    },
    methods: {
        hasOwnersData() {
            return this.owners > 0;
        }
    }
};
</script>

<style>
</style>